import client from './client'
import type { Utente } from '@/types'

export const authApi = {
  login: async (email: string, password: string): Promise<{ utente: Utente; access_token?: string; refresh_token?: string }> => {
    const res = await client.post('/auth/login', { email, password })
    return res.data
  },

  logout: async (): Promise<void> => {
    await client.post('/auth/logout')
  },

  refresh: async (): Promise<void> => {
    await client.post('/auth/refresh')
  },

  me: async (): Promise<Utente> => {
    const res = await client.get('/auth/me')
    return res.data
  },
}
